<template>
    <v-dialog
        v-model="activate"
        max-width="900px"
        persistent
    >
        <v-card class="px-4" color="background">
            <v-card-title>
            <vuse-section-definition
                :title="formTitle"
                icon="mdi-phone"
                class="ml-n4 pa-0 pb-4" />
            </v-card-title>
            <v-card-text>
                <v-container class="mb-2 pa-0">
                    <v-form ref="nodesForm">
                    <v-sheet class="neu-glow px-6">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.name"
                                    @input="validate"
                                    :label="$t('Global.Nodes.name')+'*'"
                                    :rules="[ requiredRule, limitTo50 ]"
                                    counter="50"
                                    required
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.description"
                                    @input="validate"
                                    :label="$t('Global.Nodes.description')+'*'"
                                    :rules="[ requiredRule, limitTo100 ]"
                                    counter="100"
                                    required
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.xsiNodeId"
                                    @input="validate"
                                    :label="$t('Global.Nodes.xsiNodeId')"
                                    :rules="[ limitTo50 ]"
                                    counter="50"
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.extensionNumber"
                                    @change="validate"
                                    :label="$t('Global.Nodes.extension')+'*'"
                                    :rules="[ requiredRule, limitTo20 ]"
                                    counter="20"
                                    required
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-select
                                    v-model="editedItem.nodeTypeId"
                                    :items="nodeTypeList"
                                    @input="validate"
                                    item-text="nodeTypeDesc"
                                    item-value="nodeTypeId"
                                    :label="$t('Global.Nodes.type')+'*'"
                                    :rules="[ requiredRule ]"
                                    required
                                    :menu-props="{ bottom: false, offsetY: true }"
                                ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-select
                                  v-model="editedItem.officeId"
                                  :items="officeList"
                                  @input="validate"
                                  item-text="callcenterOfficeName"
                                  item-value="officeId"
                                  :label="$t('Global.Nodes.office')+'*'"
                                  :rules="[ requiredRule ]"
                                  required
                                  :menu-props="{ bottom: false, offsetY: true }"
                              ></v-select>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.phoneNumber"
                                    @input="validate"
                                    :label="$t('Global.Nodes.phoneNumber')"
                                    :rules="[ limitTo50 ]"
                                    counter="50"
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.terminalType"
                                    @input="validate"
                                    :label="$t('Global.Nodes.terminal')"
                                    clearable
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-text-field
                                    v-model="editedItem.emailWebex"
                                    @input="validate"
                                    :label="$t('Global.Nodes.emailWebex')"
                                    :rules="[ validEmail, limitTo100 ]"
                                    counter="100"
                                    clearable
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-sheet>
                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeDialog">{{ $t('Global.Nodes.cancel') }}</v-btn>
            <v-btn color="blue darken-1" text @click="submitItem" :disabled="!validForm">{{ $t('Global.Nodes.save') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import {mapGetters} from "vuex";
import Utils from "@/mixins/Utils";

export default {
    name: "NodesDialog",
  mixins: [Utils],
    props: {
        activate: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            editedItem: {
              emailWebex: "",
              extensionNumber: "",
              description: "",
              nodeId: "",
              name: "",
              nodeTypeId: "",
              officeId: "",
              phoneNumber: "",
              terminalType: "",
              xsiNodeId: ""
            },
            defaultItem: {
              emailWebex: "",
              extensionNumber: "",
              description: "",
              nodeId: "",
              name: "",
              nodeTypeId: "",
              officeId: "",
              phoneNumber: "",
              terminalType: "",
              xsiNodeId: ""
            },
            nodeTypeList: [],
            officeList: [],
            requiredRule: v => !!v || this.$t('Global.FormRules.requiredField'),
            validEmail: v => v == null || v === "" || !!v.match(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/) ? true : this.$t('Global.FormRules.invalidFormat'),
            limitTo20: v => v.length <= 20 ? true : this.$t('Global.FormRules.characterLimit'),
            limitTo50: v => v.length <= 50 ? true : this.$t('Global.FormRules.characterLimit'),
            limitTo100: v => v.length <= 100 ? true : this.$t('Global.FormRules.characterLimit'),
            validForm: false

        }
    },
    computed: {
      ...mapGetters(['getDefsNodeTypes']),
        formTitle() {
            return !this.item ? this.$t('Global.Nodes.newNode') : this.$t('Global.Nodes.editNode');
        }
    },
    methods: {
        validate() {
            this.validForm = this.$refs.nodesForm.validate()
        },
        closeDialog() {
            this.editedItem = Object.assign({}, this.defaultItem)
            this.$emit('close-dialog')
        },
        submitItem() {
            for (const prop in this.editedItem ) {
                if (this.editedItem[prop] === null) this.editedItem[prop] = ""
            }
            if (this.item)
                this.$emit('update-item', this.editedItem)
            else
                this.$emit('create-item', this.editedItem)
            this.closeDialog()
        }
    },
    mounted(){
      this.nodeTypeList = this.getDefsNodeTypes
      this.officeList = this.loadCompanyOffices()
        if (this.item) {
            this.editedItem = Object.assign({}, this.item)
        }
        else
            this.editedItem = Object.assign({}, this.defaultItem)
    }
}
</script>

